var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.77,
    height: 10.77,
    viewBox: "0 0 10.77 10.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1791EA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.386 10.27A4.89 4.89 0 01.5 5.387 4.89 4.89 0 015.386.5a4.89 4.89 0 014.885 4.886 4.89 4.89 0 01-4.885 4.885zm-2.24-4.602L4.678 7.2l2.947-2.946-.093-.093-2.5 2.5-.354.353-.353-.353-1.086-1.086-.093.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.386 1a4.385 4.385 0 100 8.77 4.385 4.385 0 000-8.77m-.708 6.79a.282.282 0 01-.2-.083L2.64 5.868a.283.283 0 010-.4l.4-.4a.282.282 0 01.4 0l1.24 1.239 2.653-2.653a.282.282 0 01.4 0l.4.4c.11.11.11.29 0 .4L4.878 7.707a.282.282 0 01-.2.083M5.386 0a5.391 5.391 0 015.385 5.386 5.391 5.391 0 01-5.385 5.385A5.391 5.391 0 010 5.386 5.391 5.391 0 015.386 0z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a664a727.svg";
export { ForwardRef as ReactComponent };